export default "__VITE_ASSET__eKHh4$_C__"